<template>
  <el-card>
    <div slot="header">
      <span v-text="title"></span>
    </div>

    <el-table :data="tableData" v-loading="loading" border fit stripe>
      <el-table-column
        prop="sortNum"
        label="序号"
        min-width="60"
        align="center"
      />
      <el-table-column prop="mavinName" label="姓名" min-width="130" />
      <el-table-column prop="safeIdCard" label="身份证" min-width="150" />
      <el-table-column label="性别/民族/年龄/专业技术职称" min-width="175">
        <template slot-scope="scope">
          {{ scope.row.sex }}、{{ scope.row.nation }}、{{ scope.row.age }}
          <div>
            {{ scope.row.appellation }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="deptName" label="工作单位" min-width="150" />
      <el-table-column label="人员行业分类/行政级别" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.industry }}、{{ scope.row.executLevel }}
        </template>
      </el-table-column>
      <el-table-column
        prop="speName"
        label="主要从事的专业方向（研究学科）"
        min-width="175"
      />
      <el-table-column prop="minorName" label="二级专业" min-width="100" />
      <el-table-column label="操作" width="95" align="center">
        <template slot-scope="scope">
          <el-button
            size="smalll"
            type="text"
            v-show="forbidOper && allowPrcs"
            @click="handleDelete(scope.row.mavinEid)"
          >
            删除
          </el-button>
          <el-button
            size="smalll"
            type="text"
            @click="handleView(scope.row.mavinEid)"
          >
            详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import { eventBus } from '@/utils/event-bus.js';
import { seledManualList, seledDelete } from '@/api/position/gains/mavin.js';

export default {
  data() {
    return {
      loading: false,
      tableData: []
    };
  },
  computed: {
    forbidOper() {
      return this.useType == 2;
    }
  },
  props: {
    useType: {
      type: Number,
      default: 0
    },
    title: {
      type: String
    },
    allowPrcs: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleView(mavinEid) {
      window.open(`/position/base/review/${mavinEid}`, 'handleView');
    },
    handleDelete(mavinEid) {
      this.$confirm('从已选专家中删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        seledDelete(this.$route.params.gainEid, mavinEid).then(res => {
          this.loading = false;

          eventBus.$emit('auditScope');
          this.list();
        });
      });
    },
    list() {
      this.loading = true;
      seledManualList(this.$route.params.gainEid, {
        keyword: this.keyword,
        useType: this.useType
      }).then(res => {
        this.tableData = res;
        this.loading = false;
      });
    }
  },
  created() {
    eventBus.$on('auditOwn', () => {
      if (this.forbidOper) {
        this.list();
      }
    });

    this.list();
  }
};
</script>

<style></style>
